<template>
    <div id="app">
        <div id="nav">
            <router-link v-if="this.$session.exists()" to="/login" v-on:click="this.logout()" replace>
             <!-- <mdb-btn color="default" v-on:click.native="logout()>Logout</mdb-btn> -->
            </router-link>
        </div>
        <router-view/>
    </div>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {
            }
        },
        mounted() {
            if(!this.$session.exists() && this.$route.name != "video-no-auth") {
                this.$router.replace({ name: "login" });
            }
        },
        beforeCreate: function() {
            if (!this.$session.exists() && this.$route.name != "video-no-auth") {
                this.$router.replace({name: "login"});
            }
        },
        components: {
        }
    }
</script>

<style>
.app {
  margin: 0 auto;
  font-family: sans-serif;
  background-color: #ccf7e2;
  padding: 10px;
  border-radius: 5px;
  max-width: 500px;
}

.login {
  margin: 0 auto;
}

</style>